<div class="form-item">
  <label class="form-label" for="{{label + side}}">{{label}}</label>
  <div class="form-input">
    <mat-radio-group [(ngModel)]="yesNo" (change)="updateRecord()">
      <mat-radio-button [value]="1">Yes</mat-radio-button>
      <mat-radio-button [value]="0">No</mat-radio-button>
    </mat-radio-group>
  </div>
  <div>
  </div>
  <div>

  <app-additional-record-image *ngIf="image=='' "  (onPhotoUpload)="loadPhoto()" matTooltip="Upload Photo"  [recordId]="recordId" [id]="id" [side]="side" [inspectionId]="inspectionId" [type]="1"></app-additional-record-image>

  <i  *ngIf="image != ''"  class="material-icons upload-container__icon" style ="border: 1px solid #ed5565;color: #ed5565; padding: 8px; margin-left: 8px;    cursor: pointer;"  (click)="viewPhoto()" >
    add_a_photo
  </i>
  </div>
</div>
